import type { IOrganizationPermission } from './OrganizationPermission.interface';

export default class OrganizationPermission implements IOrganizationPermission {
  owner: boolean;
  team: boolean;
  organization: boolean;

  static build = (data: IOrganizationPermission) => new OrganizationPermission(data);
  static blank = () => new OrganizationPermission();

  /**
   * Constructor
   * @param {IOrganizationPermission} data
   */
  constructor(data?: IOrganizationPermission) {
    this.owner = data?.owner === true;
    this.team = data?.team === true;
    this.organization = data?.organization === true;
  }
}
